import React, { useState, useEffect } from "react";
import styles from "../MyKohere/Account.module.css";
import Layout from "../../Components/Layout";
import Subscribe from "../ComapnyDetails/Subscribe";
import { useNavigate } from "react-router-dom";
import {
    getMykohere,
    getcreditPurchaseHistory,
} from "../../Services/APIrequests";
import { warningSwal } from "../../Util/Toast";
import SubscriptionPage from "../ComapnyDetails/subscription_page";
import SubscriptionPageCOntacts from "../ComapnyDetails/subscription_page_contacts";
import { useLocation } from "react-router-dom";
import { set } from "lodash";
const Mycredits = () => {
    const location = useLocation();

    const [activeTab, setActiveTab] = useState("personalInfo");
    const [userData, setUserData] = useState(null);
    const [history, setHistory] = useState([]);
    const [loading, setLoading] = useState(true);

    const navigate = useNavigate();

    // Tab switching
    const handleTabChange = (tab) => {
        setActiveTab(tab);
    };
    useEffect(() => {
        if (location?.state && location?.state.active) {
            setActiveTab(location.state.active);
        }
    }, []);

    // Fetch user data
    const fetchUserData = async () => {
        const token = sessionStorage.getItem("token");
        if (!token) {
            navigate("/");
            return;
        }
        try {
            const response = await getMykohere(token);
            setUserData(response.data.user);
        } catch (error) {
            console.error("Error fetching user data:", error);
        }
    };

    // Fetch credit purchase history
    // Fetch credit purchase history
    const fetchPurchaseHistory = async (type) => {
        try {
            const response = await getcreditPurchaseHistory(type);
            if (
                response?.data?.history &&
                Array.isArray(response.data.history)
            ) {
                setHistory((prev) => [
                    ...prev,
                    ...response.data.history?.map((item) => ({
                        ...item,
                        type:
                            type === "credit"
                                ? "Company Credits"
                                : "Business for Sale",
                    })),
                ]);
            } else {
                setHistory([]); // just set empty array instead of showing swal
            }
        } catch (err) {
            console.error("Failed to fetch purchase history:", err);
            setHistory([]); // fallback to empty data
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchUserData();
        fetchPurchaseHistory("credit");
        fetchPurchaseHistory("contact");
    }, []);

    return (
        <div>
            <Layout Active={"My Credits"}>
                <div className={styles.accountContainer}>
                    <div className={styles.accountSidebar}>
                        <ul>
                            <li
                                className={
                                    activeTab === "personalInfo"
                                        ? styles.accountActive
                                        : ""
                                }
                                onClick={() => handleTabChange("personalInfo")}>
                                My Credits
                            </li>
                            <li
                                className={
                                    activeTab === "CreditsPurchase"
                                        ? styles.accountActive
                                        : ""
                                }
                                onClick={() =>
                                    handleTabChange("CreditsPurchase")
                                }>
                                Credits Purchase History Details
                            </li>
                            <li
                                className={
                                    activeTab === "BuyCredits"
                                        ? styles.accountActive
                                        : ""
                                }
                                onClick={() => handleTabChange("BuyCredits")}>
                                Buy Company Credits
                            </li>
                            <li
                                className={
                                    activeTab === "ContactCredits"
                                        ? styles.accountActive
                                        : ""
                                }
                                onClick={() =>
                                    handleTabChange("ContactCredits")
                                }>
                                Business for Sale Credits
                            </li>
                        </ul>
                    </div>

                    <div className={styles.accountmain_container}>
                        <div className={styles.accountMain}>
                            <div className={styles.accountDetails}>
                                {activeTab === "personalInfo" && (
                                    <div className={styles.credits_data}>
                                        <div className={styles.profile_datas}>
                                            <p id={styles.data}>
                                                <b>Available Credits:</b>{" "}
                                                <span
                                                    style={{
                                                        color: "var(--PrimaryColor)",
                                                    }}>
                                                    {userData
                                                        ? userData.credits
                                                        : 0}
                                                </span>
                                            </p>
                                            <p id={styles.data}>
                                                <b>Contacts Credits:</b>{" "}
                                                <span
                                                    style={{
                                                        color: "var(--PrimaryColor)",
                                                    }}>
                                                    {userData
                                                        ? userData.contactCredits
                                                        : 0}
                                                </span>
                                            </p>
                                        </div>
                                    </div>
                                )}

                                {activeTab === "CreditsPurchase" && (
                                    <>
                                        <div
                                            className={
                                                styles.CreditsPurchase_heading
                                            }>
                                            <h2>
                                                Credits Purchase History Details
                                            </h2>
                                        </div>

                                        <div className={styles.tableWrapper}>
                                            <table
                                                className={styles.commantable}>
                                                <thead>
                                                    <tr
                                                        className={
                                                            styles.tableHeaderRow
                                                        }>
                                                        <th
                                                            className={
                                                                styles.tableHeader
                                                            }>
                                                            Date of Purchase
                                                        </th>
                                                        <th
                                                            className={
                                                                styles.tableHeader
                                                            }>
                                                            Type
                                                        </th>
                                                        <th
                                                            className={
                                                                styles.tableHeader
                                                            }>
                                                            Credits Purchased
                                                        </th>
                                                        <th
                                                            className={
                                                                styles.tableHeader
                                                            }>
                                                            Credits Expiring in
                                                            30 Days
                                                        </th>
                                                        <th
                                                            className={
                                                                styles.tableHeader
                                                            }>
                                                            Credits Expired
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {history.length > 0 ? (
                                                        history.map(
                                                            (entry, index) => (
                                                                <tr key={index}>
                                                                    <td>
                                                                        {new Date(
                                                                            entry.purchaseDate
                                                                        ).toLocaleDateString(
                                                                            "en-GB",
                                                                            {
                                                                                day: "2-digit",
                                                                                month: "short",
                                                                                year: "numeric",
                                                                            }
                                                                        )}
                                                                    </td>
                                                                    <td>
                                                                        {
                                                                            entry.type
                                                                        }
                                                                    </td>
                                                                    <td
                                                                        style={{
                                                                            textAlign:
                                                                                "center",
                                                                        }}>
                                                                        {
                                                                            entry.credits
                                                                        }
                                                                    </td>
                                                                    <td
                                                                        style={{
                                                                            textAlign:
                                                                                "center",
                                                                        }}>
                                                                        {
                                                                            entry.creditsExpiringIn30Days
                                                                        }
                                                                    </td>
                                                                    <td
                                                                        style={{
                                                                            textAlign:
                                                                                "center",
                                                                        }}>
                                                                        {
                                                                            entry.creditsExpired
                                                                        }
                                                                    </td>
                                                                </tr>
                                                            )
                                                        )
                                                    ) : (
                                                        <tr>
                                                            <td
                                                                colSpan="4"
                                                                style={{
                                                                    textAlign:
                                                                        "center",
                                                                    padding:
                                                                        "10px",
                                                                }}>
                                                                No data found
                                                            </td>
                                                        </tr>
                                                    )}
                                                </tbody>
                                            </table>
                                        </div>
                                    </>
                                )}

                                {activeTab === "BuyCredits" && (
                                    <div
                                        className={
                                            styles.subscriptionContainer
                                        }>
                                        <SubscriptionPage />
                                    </div>
                                )}
                                {activeTab === "ContactCredits" && (
                                    <div
                                        className={
                                            styles.subscriptionContainer
                                        }>
                                        <SubscriptionPageCOntacts
                                            redirect={location?.state?.from}
                                        />
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </Layout>
        </div>
    );
};

export default Mycredits;
